// toDo: initiai states
function HomeReducer(state = {}, action) {
  switch (action.type) {
    case 'HOME_DATA_SUCCESS':
      return action.home;
    default:
      return state;
  }
}

export default HomeReducer;
